import PhoneNumber from "../../../../../common/types/phone-number";
import appTranslationsHelper from "../../../../../languages/app-translations.helper";
import SignUpPassengerAddress from "../common/types/sign-up-passenger-address";

const getMobileString = (phone: PhoneNumber): string => {
  if (!phone.dialingCode || !phone.number) {
    return appTranslationsHelper.getPassengerSignUpTranslations().summary
      .noFillDataText;
  }

  return `${phone.dialingCode} ${phone.number}`;
};

const getDateString = (date: Date): string => {
  return date.toLocaleDateString();
};

const getAddressString = (address: SignUpPassengerAddress): string => {
  const addressString = `${address.street} ${
    address.houseNumber && address.apartmentNumber
      ? `${address.houseNumber}/${address.apartmentNumber}`
      : `${address.houseNumber}`
  }, ${address.zipCode} ${address.town}`;

  return addressString;
};

const signUpPassengerSummaryHelper = {
  getMobileString,
  getDateString,
  getAddressString,
};

export default signUpPassengerSummaryHelper;
